import React from 'react'
import { CssBaseline, ThemeProvider } from '@mui/material'
import { ErrorBoundary } from 'react-error-boundary'

import AppProvider from './components/AppContext/AppProvider'
import MainContainer from './pages/Main/Main.container'
import { theme } from './services/muiTheme.config'
import { logger } from './services/logger'

import {
  DefaultErrorBoundary,
  defaultErrorHandler
} from './components/DefaultErrorBoundary'
import Amplitude from './components/Amplitude/Amplitude.container'
import Branch from './components/Branch/Branch.container'
import BranchLinkContainer from './components/Branch/BranchLink.container'

export const App: React.FC = (): JSX.Element => {
  logger.debug('Loading App')

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Amplitude />
      <Branch />
      <ErrorBoundary
        FallbackComponent={DefaultErrorBoundary}
        onError={defaultErrorHandler}
      >
        <AppProvider>
          <BranchLinkContainer>
            <MainContainer />
          </BranchLinkContainer>
        </AppProvider>
      </ErrorBoundary>
    </ThemeProvider>
  )
}

export default App
